
<ng-template #template>
    <div class="modal-body position-relative">
        <div *ngIf="!message">
            <div class="text-dark-75 h2 mb-10 ml-5">
                {{'AreyousureyouwanttoDelete'| localize}}
                <button type="button" class="close" (click)="cancel()"><i aria-hidden="true" class="ki ki-close"></i></button>

            </div>

            <div class="mb-10 ml-5">

                <span *ngIf="message != ''">
                    Select an individual user and resolve dependencies for <b> {{message}}</b>
                    while deleting the other four users.
                </span> <br>
                {{'Youcantundothisaction' | localize}}
            </div>
            <div class="d-flex justify-content-start">
                <button class="btn btn-outline-danger rounded-0 w-50 mx-6" (click)="cancel()">
                    {{'No' | localize}}
                </button><button class="btn btn-primary rounded-0 w-50 mx-6" (click)="yes()">{{'Yes' | localize}}</button>
            </div>
            <span class="position-absolute" style="top: 1rem; left: -2.5rem;">
                <img src="../../../.././../assets/common/images/modalpopup/Group 142322.svg" style="width: 5rem;">
            </span>

        </div>

        <div *ngIf="message">
            <div class="mb-10">
                <button type="button" class="close" (click)="cancel()"><i aria-hidden="true" class="ki ki-close"></i></button>
            </div>
            <div class="text-center">
                <img src="../../../.././../assets/common/images/modalpopup/Group 197280.svg" style="width: 3rem;">
            </div>

            <div class="text-dark-75 h3 mb-5  mt-10 text-center">
                Alert! Resolve dependencies
            </div>
            <div class="text-dark-50 mb-5 text-center">
                Choose individual user to resolve the dependencies and then proceed to delete.
            </div>

            <div>
                <ul>
                    <li *ngFor="let item of message.split(',')">
                        {{item}}
                    </li>
                </ul>
            </div>

            <div class="d-flex justify-content-center mt-5">
                <button class="btn btn-outline-danger rounded-0 w-25 mx-6" (click)="cancel()">
                    {{'Close' | localize}}
                </button>
            </div>
        </div>

    </div>
</ng-template>


